// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"jba-z","colorTextValue":"kba-z","swatches":"lba-z","collapseLink":"mba-z","isCollapsed":"nba-z","dropdown":"oba-z","disabled":"pba-z"};